import { captureMessage } from '@sentry/browser';
import React from 'react';

import { ReactComponent as InfoIcon } from 'src/assets/svgs/icon-circle-info-orange.svg';
import { ReactComponent as ErrorIcon } from 'src/assets/svgs/icon-orange-error.svg';
import { ReactComponent as WarningIcon } from 'src/assets/svgs/icon-triangle-warning.svg';

export enum InfoBannerTestID {
  InfoIcon = 'InfoBannerTestID.InfoIcon',
  WarningIcon = 'InfoBannerTestID.WarningIcon',
  ErrorIcon = 'InfoBannerTestID.ErrorIcon',
}

export enum BannerState {
  Info = 'info',
  Warning = 'warning',
  Error = 'error',
}

export interface Props {
  message: string;
  bannerState?: BannerState;
}

export const InfoBanner: React.FC<Props> = ({ message, bannerState = BannerState.Info }) => {
  let bannerIcon = (
    <InfoIcon data-testid={InfoBannerTestID.InfoIcon} height={14} title="info icon" />
  );
  switch (bannerState) {
    case BannerState.Info:
      // Already the default.
      break;
    case BannerState.Warning:
      bannerIcon = (
        <WarningIcon data-testid={InfoBannerTestID.WarningIcon} height={14} title="warning icon" />
      );
      break;
    case BannerState.Error:
      bannerIcon = <ErrorIcon data-testid={InfoBannerTestID.ErrorIcon} title="error icon" />;
      break;
    default:
      const exhaustiveCheck: never = bannerState;
      captureMessage(`Unknown banner state: ${exhaustiveCheck}`);
  }

  return (
    <div className="min-w-full bg-orange-300 rounded p-3 mb-5 flex items-center">
      {bannerIcon}
      <p className="text-sm font-extrabold text-grey-850 ml-3">{message}</p>
    </div>
  );
};
